import { BaseInput } from "shared/components/forms/BaseInput";
import { type CredentialFormProps } from "./types";
import { BoolCheckbox } from "./fields/BoolCheckbox";
import { FormSection } from "./fields/FormSection";

export const YardiCredentialForm = ({ register }: CredentialFormProps) => {
  const enableAppCharge = register("yardi_enable_application_charge");
  const enableScreeningCharge = register(
    "yardi_enable_screening_services_charge"
  );
  const enableTemplateFeeCharges = register(
    "yardi_enable_template_fee_charges"
  );
  const useLeaseTerm = register("yardi_use_lease_term");

  return (
    <>
      <BaseInput
        id="yardi_web_service_url"
        label="URL"
        {...register("yardi_web_service_url")}
        required
      />
      <BaseInput
        id="yardi_username"
        label="User name"
        {...register("yardi_username")}
        required
      />
      <BaseInput
        id="yardi_password"
        label="Password"
        {...register("yardi_password")}
        required
      />
      <BaseInput
        id="yardi_server_name"
        label="Server name"
        {...register("yardi_server_name")}
        required
      />
      <BaseInput
        id="yardi_database"
        label="Database"
        {...register("yardi_database")}
        required
      />

      <FormSection title="Charges">
        <BoolCheckbox
          label="Enable application charge"
          field={enableAppCharge}
        />
        {enableAppCharge.value === true && (
          <BaseInput
            id="yardi_application_charge_code"
            label="Application charge code"
            {...register("yardi_application_charge_code")}
          />
        )}

        <BoolCheckbox
          label="Enable template fee charges"
          field={enableTemplateFeeCharges}
        />
        {enableTemplateFeeCharges.value === true && (
          <>
            <BaseInput
              id="yardi_administration_fee_charge_code"
              label="Administration fee charge code"
              {...register("yardi_administration_fee_charge_code")}
            />
            <BaseInput
              id="yardi_holding_fee_charge_code"
              label="Holding fee charge code"
              {...register("yardi_holding_fee_charge_code")}
            />
          </>
        )}

        <BoolCheckbox
          label="Enable screening services charge"
          field={enableScreeningCharge}
        />
        {enableScreeningCharge.value === true && (
          <>
            <BaseInput
              id="yardi_screening_services_charge_code"
              label="Screening services charge code"
              {...register("yardi_screening_services_charge_code")}
            />
            <BaseInput
              id="yardi_general_ledger_account"
              label="General ledger account"
              {...register("yardi_general_ledger_account")}
            />
          </>
        )}

        <BoolCheckbox label="Use lease term" field={useLeaseTerm} />
      </FormSection>
    </>
  );
};
